import styled from 'styled-components';
import { createTheme } from '@mui/material/styles';

export const Container = styled.div`
  width: 100%;

  p {
    color: #0B0C0C;
    font-size: 19px;
    font-weight: 400;
    line-height: 130%;
    font-style: normal;
    margin: 56px 0 20px 0;
  }

  .range_wrapper {
      display: flex;
      align-items: center;

      input::placeholder {
        padding: 0 16px;
      }

      input {
        width: 71px;
        height: 20px;
        max-width: 85px;
        padding: 16px 5px;
        border-radius: 4px;
        border: .5px solid gray;
      }
    }
`;

export const materialTheme = createTheme({
  palette: {
    primary: {
      main: '#2196F3',
    },
    secondary: {
      main: '#0B0C0C',
    },
  },
});